export default __webpack_public_path__ + "static/media/explore-icon.b99c382b.svg";